import axios from 'axios';

const getService = () => {
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  return window.location.origin;
};

export const service_ip = getService();

export const fetch = (params) => {
  return new Promise((resolve, reject) => {
    const method = params.method || 'get';
    const data = method === 'post' ? paramsHandler(params.data || {}) : params.data;

    axios({
      ...params,
      url: `${service_ip}${params.url}`,
      method,
      data,
      params: method === 'get' ? data : {},
      withCredentials: true,
      timeout: 10000,
    })
      .then((res) => {
        let response = res;
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }

        const result = response.data;
        if (result && result.code === 1) {
          resolve(result.data);
        } else {
          reject(new Error(result?.msg || 'Request failed'));
        }
      })
      .catch((error) => {
        if (error.code === 'ECONNABORTED') {
          reject(new Error('Request timeout'));
          return;
        }
        reject(error);
      });
  });
};

export const paramsHandler = function (v) {
  const formData = new FormData();
  for (const key in v) {
    formData.append(key, v[key]);
  }
  return formData;
};

export const isMobile = () => {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  const windowWidth = window.innerWidth;
  return flag || windowWidth < 1024;
};

export const msgCode = (n) => {
  if (n === undefined) {
    return '未知错误';
  }
  n = n.toString();
  switch (n) {
    case '100':
      return 'json解析错误';
    default:
      return '未知错误';
  }
};
